
import React from 'react'
import { Link } from 'react-router';
import Select from 'react-select';
import {injectIntl, intlShape, FormattedRelative} from 'react-intl';

import UserSelect from '../Shared/UserSelect';
import * as constants from '../../constants';

var NotificationSystem = require('react-notification-system');


class InitiativeForm extends React.Component {

   constructor(props) {
    super(props);
    this.state = {
      initiative : {
        TypeId : -1,
        Authors : [],
        HideName : false,
        State : constants.INITIATIVE_STATE_NEW,
        ManagerId : -1
      },
      originatorId : -1,
      Valid : false,
      FileCount : 0, 
      Files : []
    };
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
  }

  handleTypeChange(event){
     const { initiative } = this.state;
     initiative.TypeId = event ? event.Id : -1;
     this.setState({
       initiative : initiative,
       Valid : this.canSubmit(initiative)
     });

  }

  handleUserSelect(event){
    const selectedOriginator = event;
    const originatorId = event ? event.Id : -1;
    this.setState({
       originatorId : originatorId,
       selectedOriginator : selectedOriginator
     });
  }

  handleAddOriginator(event){
    
     var initiative = this.state.initiative; 
     var Authors = [...initiative.Authors];
     const selectedOriginator = this.state.selectedOriginator;

     const {onFetchUserManager} = this.props;



    const {intl} = this.props;
    const t = (message, data = {}) => {
        if(!message) return '';
        return intl.formatMessage({id : message}, data);
    };
      
     if(selectedOriginator){
        var added = false;
        Authors.forEach((o) => {
           added = added || (selectedOriginator.Id == o.Id);
        });
        if(added){
          this._notificationSystem.addNotification({
            title : t("Failed"),
            message: t('ADD_ORIGINATOR_FAILED'),
            level: 'error',
            position : 'br'
          });
        }
        else
        { 
          var ManagerId = this.state.initiative.ManagerId;
          if( (!ManagerId || ManagerId < 0) && selectedOriginator.ManagerId){
             ManagerId = selectedOriginator.ManagerId;
          }
          Authors.push(selectedOriginator);
          initiative.Authors = Authors;
          initiative.ManagerId = ManagerId;
          this.setState({originatorId : -1, initiative : initiative, Valid : this.canSubmit(initiative)});
        }
    }
  }

  handleRemoveOriginator(user){
      const id = user.Id;
      var initiative = this.state.initiative; 
      var ManagerId = initiative.ManagerId;

      var Authors = initiative.Authors;
      Authors = Authors.filter((o)=>{
        return o.Id != id;
      });
      if(ManagerId === user.ManagerId){
        ManagerId = -1;
        Authors.every((a) => {
          if(a.ManagerId >= 0){
            ManagerId = a.ManagerId;
            return false;
          }
          return true;
        });
      }
      initiative.ManagerId = ManagerId;
      initiative.Authors = Authors;
      this.setState({initiative : initiative, Valid : this.canSubmit(initiative)});
  }

  handleInputChange(propertyName, event){
    var value = typeof event === 'object' ? event.target.value : event;
    if(propertyName === 'HideName'){
       value = event.target.checked ? true : false;
    }
    let initiative  = Object.assign(this.state.initiative, 
          {[propertyName] : value}
    );
    this.setState({
      initiative : initiative,
      Valid : this.canSubmit(initiative)
    });
  }

  onFileUpload(event){
      this.setState({
        Files : event.target.files,
        FileCount : event.target.files.length
      });
  }

  changeManager(newManagerId){
      var initiative = this.state.initiative;
      initiative.ManagerId = newManagerId;
      this.setState({initiative : initiative});
  }

  canSubmit(initiative){
    return initiative.TypeId && initiative.ManagerId && initiative.ManagerId > 0 && initiative.Title && initiative.Improvement && initiative.CurrentSituation && initiative.Authors && initiative.Authors.length > 0;
  }

  submitNewInitiative(){
      const {onPostIdea} = this.props;
      if(onPostIdea){
        this.setState({
          Loading : true
        });
        onPostIdea(this.state.initiative, this.state.Files).then((resp) => {
          if(resp.value){
            //reset state
            setTimeout(()=>{
              this.setState(
                {
                  initiative : {
                    TypeId : -1,
                    Authors : [],
                    HideName : false,
                    State : constants.INITIATIVE_STATE_NEW
                  },
                  originatorId : -1,
                  Valid : false,
                  FileCount : 0, 
                  Files : []
                }
              );
            }, 3000);
          }
        },
        (exp) => {
          this.setState({
            Loading : false
          });
        }
        );
      }
  }

  render() {  
    const {intl} = this.props;
    const t = (message, data = {}) => {
        if(!message) return '';
        return intl.formatMessage({id : message}, data);
    };
    const { initiativeTypes } = this.props;
    const { initiative } = this.state;
    const {Authors} = initiative;
    return (
        <form>
                 <NotificationSystem ref="notificationSystem" />
                <div className="form-group">
                  <label>* {t('INITIATIVE_NAME')}</label>
                  <input className="form-control" placeholder={t('INITIATIVE_NAME')} value={initiative.Title} onChange={this.handleInputChange.bind(this, 'Title')}/>
                  <p className="help-block">{t('INITIATIVE_NAME_HELP')}</p>
                </div>
                <div className="form-group">
                    <label>* {t('Name')}</label>
                    <div className="row">
                        <div className="col-md-9">
                          <UserSelect  includeManager="true" userId={this.state.originatorId} onSelectUser={this.handleUserSelect.bind(this)} clearOnBlur={true}/>
                        </div>
                        <div className="col-md-3" style={{paddingLeft:'0px'}}>
                          <button type="button" onClick={this.handleAddOriginator.bind(this)} className="btn btn-default btn-brand pull-left">{t('Add')}</button>
                        </div>
                    </div>
                   <p className="help-block">{t('NAME_HELP')}</p>
                   <table className="table table-condensed table-bordered">
                          <thead>
                            <tr>
                                <th>#</th>
                                <th>{t('Account')}</th>
                                <th>{t('Display Name')}</th>
                                <th>{t('Manager')}</th>
                                <th>{t('Remove')}</th>
                            </tr> 
                          </thead>
                          <tbody>
                            {
                              (Authors && Authors.length <= 0) && (<tr >
                                    <td colSpan="6">
                                      <div className="alert alert-danger" style={{marginBottom : '0px'}}>
                                        <strong>{t('No name selected')}! </strong>{t('Please select a name and click')} <strong>{t('Add')}</strong>.
                                      </div>
                                      </td>
                              </tr>)
                            }
                            {
                              (Authors).map((m, idx) => 
                                (<tr key={m.Id}>
                                    <td><Link to={"/user/" + m.Id}>{m.Id}</Link></td>
                                    <td>{m.Account}</td>
                                    <td>{m.DisplayName}</td>
                                    <td>
                                      {m.ManagerId && <input type="checkbox" onChange={this.changeManager.bind(this, m.ManagerId)} 
                                          checked={initiative.ManagerId === m.ManagerId}/>}
                                      &nbsp;
                                      {m.Manager ? m.Manager.DisplayName : ''} 
                                    </td>
                                    <td><button className="btn btn-default btn-danger btn-xs" onClick={this.handleRemoveOriginator.bind(this, m)}><i className="glyphicon glyphicon-remove"/></button></td>
                                </tr>)
                              )
                            }
                          </tbody>
                    </table>
                </div>
                
                <div className="checkbox">
                  <label>
                    <input type="checkbox" checked={initiative.HideName} onChange={this.handleInputChange.bind(this, 'HideName')}/> {t('REPORT_ANONYMOUS')}
                  </label>
                </div>
                <div className="form-group">
                  <label>* {t('Type')}</label>
                  <Select
                    name="form-field-name"
                    value={initiative.TypeId}
                    options={initiativeTypes.Types}
                    onChange = {this.handleTypeChange.bind(this)}
                    placeholder = {t('Select') + '...'}
                  />
                  <p className="help-block">{t('INITIATIVE_TYPE_HELP')}</p>
                </div>
                <div className="form-group">
                  <label>* {t('CURRENT_SITUATION')}</label>
                  <textarea rows="4" className="form-control" value={initiative.CurrentSituation  || ''} onChange={this.handleInputChange.bind(this, 'CurrentSituation')}/>
                  <p className="help-block">{t('CURRENT_SITUATION_HELP')}</p>
                </div>
                <div className="form-group">
                  <label>* {t('IMPROVEMENT_PROPOSAL')}</label>
                  <textarea rows="4" className="form-control" value={initiative.Improvement || ''} onChange={this.handleInputChange.bind(this, 'Improvement')}/>
                  <p className="help-block">{t('IMPROVEMENT_PROPOSAL_HELP')}</p>
                </div>

                <div className="form-group">
                  <label>{t('Attached files')}</label>
                  <input type="file" onChange={this.onFileUpload.bind(this)} multiple/>
                  <p className="help-block">{t('ATTACH_FILES_HELP')}</p>
                </div>
                <button type="button" disabled={!this.state.Valid || this.state.Loading} className="btn btn-default btn-brand pull-right" onClick={this.submitNewInitiative.bind(this)}>
                  { this.state.Loading && 
                    <i className="fa fa-refresh fa-spin" ></i>
                  }
                  &nbsp;{t('Save and send')}
               </button>
      </form>
    );
  }
}

InitiativeForm.displayName = 'InitiativeForm';
InitiativeForm.propTypes = {};
InitiativeForm.defaultProps = {
  
};

export default injectIntl(InitiativeForm);








// WEBPACK FOOTER //
// ./components/MakeIdeas/InitiativeForm.js